import { null as zNull } from "zod";

export const disconnectBlueCherryIntegration = {
  name: "disconnectBlueCherryIntegration" as const,
  input: zNull(),
  output: zNull(),
};
